export default __webpack_public_path__ + "static/media/schoolAd.c05439e1.jpg";